/**
 * @desc 根据物流属性分组编号查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.LogisticsGroupResponseDto>;
export function request(groupNo: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/logisticsGroup/byUnique/${groupNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
